import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const scrollToSection = (sectionId) => {
    if (isHomePage) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setIsMenuOpen(false);
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      setIsMenuOpen(false);
    }
  };

  const handleServicesClick = () => {
    navigate('/services');
    setIsMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const handleAppGrowthClick = () => {
    navigate('/app-growth');
    setIsMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const handleAboutClick = () => {
    navigate('/about');
    setIsMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const handleCaseStudiesClick = () => {
    navigate('/case-studies');
    setIsMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const handleContactClick = () => {
    navigate('/contact');
    setIsMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const handleLogoClick = () => {
    navigate('/');
    window.scrollTo(0, 0);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-blue-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer" onClick={handleLogoClick}>
            <img 
              src="https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/leno967f_Group%201000004189-1.png" 
              alt="Upscale Logo" 
              className="h-10"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={handleServicesClick}
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200"
            >
              Services
            </button>
            <button
              data-testid="nav-app-growth-desktop"
              onClick={handleAppGrowthClick}
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200"
            >
              App Growth
            </button>
            <button
              onClick={() => scrollToSection('benefits')}
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200"
            >
              Benefits
            </button>
            <button
              onClick={handleAboutClick}
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200"
            >
              About
            </button>
            <button
              data-testid="nav-case-studies-desktop"
              onClick={handleCaseStudiesClick}
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200"
            >
              Case Studies
            </button>
            <button
              onClick={() => scrollToSection('clients')}
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200"
            >
              Clients
            </button>
            <Button
              onClick={handleContactClick}
              className="bg-blue-600 hover:bg-blue-700 text-white"
            >
              Contact Us
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden pb-4 space-y-2">
            <button
              onClick={handleServicesClick}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors rounded-md"
            >
              Services
            </button>
            <button
              data-testid="nav-app-growth-mobile"
              onClick={handleAppGrowthClick}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors rounded-md"
            >
              App Growth
            </button>
            <button
              onClick={() => scrollToSection('benefits')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors rounded-md"
            >
              Benefits
            </button>
            <button
              onClick={handleAboutClick}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors rounded-md"
            >
              About
            </button>
            <button
              data-testid="nav-case-studies-mobile"
              onClick={handleCaseStudiesClick}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors rounded-md"
            >
              Case Studies
            </button>
            <button
              onClick={() => scrollToSection('clients')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors rounded-md"
            >
              Clients
            </button>
            <Button
              onClick={handleContactClick}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white mt-2"
            >
              Contact Us
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;